/**
 * Haptic feedback utility for mobile devices
 * Uses the Vibration API when available
 */

export const haptics = {
  /** Light tap - for selections and toggles */
  light: () => navigator.vibrate?.(10),

  /** Medium tap - for confirmations */
  medium: () => navigator.vibrate?.(25),

  /** Heavy tap - for important actions */
  heavy: () => navigator.vibrate?.(50),

  /** Success pattern - for completed actions */
  success: () => navigator.vibrate?.([10, 50, 10]),

  /** Error pattern - for failed actions */
  error: () => navigator.vibrate?.([50, 30, 50, 30, 50]),

  /** Warning pattern - for destructive actions */
  warning: () => navigator.vibrate?.([30, 50, 30]),
};
